import React from "react";
import { useLocalization } from "@fluent/react";
import { ContextForm } from "cerulean";
import { TextInput } from "@narmi/design_system";
import type { ReactLocalization } from "@fluent/react";
import useRevalidateErroringField from "../hooks/useRevalidateErroringField";

const PASSPORT_IDENTIFIER_REGEX = /^[A-Za-z0-9]{6,15}$/;

const validatePassportNumber = (value: string, l10n: ReactLocalization) => {
  if (value && !PASSPORT_IDENTIFIER_REGEX.test(value)) {
    return l10n.getString(
      "error-invalid-passport-number",
      null,
      "Please enter a valid passport number"
    );
  }

  return null;
};

type PassportNumberFieldProps = {
  revalidateErrorsOnBlur?: boolean;
};

const PassportNumberField = ({
  revalidateErrorsOnBlur = false,
}: PassportNumberFieldProps) => {
  const { l10n } = useLocalization();
  const field = "passport_number";
  const revalidateErroringField = useRevalidateErroringField(field);

  return (
    <ContextForm.Field
      required
      validate={(value: string) => validatePassportNumber(value, l10n)}
      key={field}
    >
      <TextInput
        type="text"
        field={field}
        label={l10n.getString("label-passport-number", null, "Passport number")}
        onChange={(event) => {
          event.target.value = event.target.value.trim();
        }}
        onBlur={revalidateErrorsOnBlur ? revalidateErroringField : undefined}
      />
    </ContextForm.Field>
  );
};

export default PassportNumberField;
